jQuery(function ($) {
  const headerEl = document.querySelector(".header-wrapper");
  if (!headerEl) return;

  let lastScroll = 0;

  window.addEventListener("scroll", function () {
    const currentScroll = window.pageYOffset || 0;

    // 80px 이상 active
    if (currentScroll >= 80) headerEl.classList.add("active");
    else headerEl.classList.remove("active");

    // 미세한 움직임 무시
    if (Math.abs(currentScroll - lastScroll) < 5) return;

    // 방향에 따라 hide
    if (currentScroll > lastScroll) {
      headerEl.classList.add("hide");   // 내릴 때 위로
    } else {
      headerEl.classList.remove("hide"); // 올릴 때 내려옴
    }

    lastScroll = currentScroll;
  });

  $(".menu_drawer").click(function () {
    $(".SidebarMenu").addClass("show");
    $("body").addClass("noScroll");
    $(".pageOverlay").addClass("on");
  });

  $(".header li .mega-menu")
    .on("mouseenter", function () {
      $(this).find(".mega-menu__content").stop(true, true).fadeIn(200);
    })
    .on("mouseleave", function () {
      $(this).find(".mega-menu__content").stop(true, true).fadeOut(200);
    });
});
